//NEW STYPEPARAMS METHOD
var AUTO_SLIDE_BEHAVIOUR = {
    OFF: 'OFF',
    INTERVAL: 'INTERVAL',
    CONTINUOUS: 'CONTINUOUS',
};
export default AUTO_SLIDE_BEHAVIOUR;
//# sourceMappingURL=behaviourParams_gallery_horizontal_autoSlide_behaviour.js.map